import styled from 'styled-components'

import { Privacy } from '@all-turtles/components'

export const StyledPrivacy = styled(Privacy)``
